import { Link } from "react-router-dom";
import { Show } from "shared/components";
import { SectionCard } from "shared/app/SectionCard";
import { useAuthContext } from "providers/Auth";

// New properties inherit the company branding; a per-Community override is set on
// Settings → Branding once the property exists (CRM-1478).
export const BrandingNote = () => {
  const { type } = useAuthContext();

  return (
    <SectionCard title="Branding">
      <div className="space-y-2">
        <p className="text-sm text-content-200">
          Branding follows your company settings. You can give this Community
          its own branding after it&apos;s created.
        </p>
        <Show if={type.adminPrivileges}>
          <Link
            to="/settings/branding"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-bold text-primary-600"
          >
            Manage in Settings → Branding
          </Link>
        </Show>
      </div>
    </SectionCard>
  );
};
